export default __webpack_public_path__ + "static/media/014-video games.ba5f778d.svg";